// Please update subNavLinkZod if you update this array
export const PLANNING_TAB_LINKS = [
    {
        label: 'Filter/Search',
        value: 'filter-search',
    },
    {
        label: 'Map',
        value: 'map',
    },
    {
        label: 'Priority',
        value: 'priority',
    },
    {
        label: 'AI Chat',
        value: 'ai-chat',
    },
] as const

export const SEARCH_PARAMS_TAB_KEY = 'tab'

export type PlanningTabLink = typeof PLANNING_TAB_LINKS[number]['value']
